import { Button, Text } from "../../components";
import Styled from "./styled";
import { Flex } from "antd";
import React from "react";

const ProCard = ({
  image = "",
  title = "",
  desc = "",
  buttons = [],
  ...props
}) => {
  return (
    <Styled {...props} image={image}>
      <div className="content">
        <Text level={3} type="tertiary" children={title.toUpperCase()} />
        <Text className="m-10-t" children={desc} type="tertiary" />
        <Flex
          vertical
          gap={"1rem"}
          className="m-15-t"
          children={React.Children.toArray(
            buttons.map((button) => (
              <Button {...button} type={button?.type ?? "primary"} />
            ))
          )}
        />
      </div>
    </Styled>
  );
};

export default ProCard;
